var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12,17.9c-1.7,0-3-1.3-3-3s1.3-3,3-3c1.7,0,3,1.3,3,3S13.6,17.9,12,17.9z M12,12.9c-1.1,0-2,0.9-2,2s0.9,2,2,2s2-0.9,2-2 S13.1,12.9,12,12.9z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M18.6,22.5H5.4c-1.1,0-1.9-0.9-1.9-1.9V9.4c0-1.1,0.9-1.9,1.9-1.9H7v-1c0-2.8,2.2-5,5-5c2.8,0,5,2.2,5,5v1h1.6 c1.1,0,1.9,0.9,1.9,1.9v11.2C20.5,21.6,19.6,22.5,18.6,22.5z M5.4,8.5c-0.5,0-0.9,0.4-0.9,0.9v11.2c0,0.5,0.4,0.9,0.9,0.9h13.2 c0.5,0,0.9-0.4,0.9-0.9V9.4c0-0.5-0.4-0.9-0.9-0.9h-2.1C16.2,8.5,16,8.3,16,8V6.5c0-2.2-1.8-4-4-4s-4,1.8-4,4V8 c0,0.3-0.2,0.5-0.5,0.5H5.4z M14,8.5h-4C9.7,8.5,9.5,8.3,9.5,8V6.5C9.5,5.1,10.6,4,12,4s2.5,1.1,2.5,2.5V8 C14.5,8.3,14.3,8.5,14,8.5z M10.5,7.5h3v-1C13.5,5.7,12.8,5,12,5s-1.5,0.7-1.5,1.5V7.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLock);
export default __webpack_public_path__ + "static/media/icon-lock.f5e68ab2419d996c5c26d46886493b19.svg";
export { ForwardRef as ReactComponent };